import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export var CETELEM_POPUP_URL = 'https://www.maisonsdumonde.com/images/cetelem/cetelem-sips-v2-details.jpg';
export var GOOGLE_RECAPTCHA = 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit';
export var ABTASTY_URL = '//try.abtasty.com/e7e1a29097d0cd00265b206d2ef2f701.js';
export var GOOGLE_SITE_VERIFICATION = 'KmVlzdRb3WiCUibFfNriRiTw9cXHq9IQM9MxUFybgqU';
export var NORTON_SAFEWEB_SITE_VERIFICATION = 'aasd3iraob008vslg86ya2vgp8xe2k8f1eze6q5st7ewlkb6d772rpw4qlms1do6x2eqag1dy-0uo9hn636ivnxxz653b42rn0pqfkj1qz2lszcloe1cc96ei1zsz8xw';
export var TRUSTED_SHOP_URL = 'https://widgets.trustedshops.com/js/X21EA64BA85A3C6478276AD87B5F2FF72.js';
export var WIBILONG_JS_URL = 'https://statics.apreslachat.com/public/wpl.min.js';
export var WIBILONG_CSS_URL = 'https://imageme.wibilong.com/maisonsdumonde/css/popin-button.css';
export var OLAPIC_URL = 'https://photorankstatics-a.akamaihd.net/81b03e40475846d5883661ff57b34ece/static/frontend/latest/build.min.js';
export var PINTEREST_URL = 'https://assets.pinterest.com/js/pinit.js';
export var PRISMIC_URL = 'https://static.cdn.prismic.io/prismic.min.js';
export var SPEEDCURVE_URL = 'https://cdn.speedcurve.com/js/lux.js?id=100559410';
export var TRUSTPILOT_URL = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
export var SEQURA_URL = 'https://live.sequracdn.com/assets/sequra-checkout.min.js';
export var SEQURA_MERCHANT_REFERENCE = 'maisonsdumonde';
export var SEQURA_KEY = 'hdBlHIMnEt';
export var WOOSMAP_KEY = 'woos-a4fa4367-383c-31c0-9d45-405ddae5a6da';
export var WOOSMAP_URL = 'https://webapp.woosmap.com/webapp.js';
export var WOOSMAP_GOOGLE_URL = 'https://www.google.com/jsapi';
export var WOOSMAP_RECOMMENDATION = 'https://recommendation-js.woosmap.com/recommendation.js';
export var WOOSMAP_LOADER = 'https://sdk.woosmap.com/locator/loader.js';